import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// get all user's reservation
export const getUclReservations = createAsyncThunk(
  "uclReservation/getAllUserReservations",
  async (
    {
      page,
      currentPage,
      limit,
    }: { page: number; currentPage: number; limit: number },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(`get-ucl-reservations`, {
        withCredentials: true,
        params: {
          page,
          currentPage,
          limit,
        },
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// create new ucl reservation
export const createUclReservation = createAsyncThunk(
  "uclReservation/createUclReservation",
  async (reservationInfo: any, { rejectWithValue }) => {
    try {
      const result = await axios.post(
        `create-ucl-reservation`,
        reservationInfo,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// cancel ucl reservation
export const cancelUclReservation = createAsyncThunk(
  "uclReservation/cancelUclReservation",
  async (
    { reservationID, data }: { reservationID: String | undefined; data: any },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.put(
        `cancel-ucl-reservation/${reservationID}`,
        data,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// cancel ucl reservation
export const updateUclReservation = createAsyncThunk(
  "uclReservation/updateUclReservation",
  async ({ reservationID, data }: any, { rejectWithValue }) => {
    try {
      const result = await axios.put(
        `update-ucl-reservation/${reservationID}`,
        data,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// resend ucl reservation
export const uclResendReservation = createAsyncThunk(
  "uclReservation/resend-ucl-reservation",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.post(`resend-ucl-reservation`, data, {
        withCredentials: true,
      });
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get list of ucl reservations to be exported on csv file
export const uclExportReservationsList = createAsyncThunk(
  "uclReservation/ucl-export-reservations-list",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.post(`export-ucl-reservations-list`, data, {
        withCredentials: true,
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get list of ucl reservations to be exported on csv file
export const uclArchivedReservationsList = createAsyncThunk(
  "uclReservation/get-archived-ucl-reservations-list",
  async (
    {
      page,
      currentPage,
      limit,
    }: { page: number; currentPage: number; limit: number },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(`get-archived-ucl-reservations-list`, {
        withCredentials: true,
        params: {
          page,
          currentPage,
          limit,
        },
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// delete ucl reservation
export const uclDeleteSingleReservation = createAsyncThunk(
  "uclReservation/delete-ucl-reservation",
  async (
    { reservationID, data }: { reservationID: String | undefined; data: any },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.put(
        `delete-ucl-reservation/${reservationID}`,
        data,
        {
          withCredentials: true,
        },
      );

      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const filterUclReservations = createAsyncThunk(
  "uclReservation/filter-ucl-reservations-list",
  async (
    {
      query,
      carType,
      status,
      startDate,
      endDate,
      actionType,
    }: {
      query: string | null;
      carType: string;
      status: string;
      startDate: string | Date | null;
      endDate: string | Date | null;
      actionType: "FILTER" | "RESET" | "FETCH" | null;
    },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(`filter-ucl-reservations-list`, {
        withCredentials: true,
        params: {
          query,
          carType,
          status,
          startDate,
          endDate,
          actionType,
        },
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const filterArchivedUclReservations = createAsyncThunk(
  "uclReservation/filter-archived-ucl-reservations-list",
  async (
    {
      query,
      carType,
      status,
      startDate,
      endDate,
      actionType,
    }: {
      query: string | null;
      carType: string;
      status: string;
      startDate: string | Date | null;
      endDate: string | Date | null;
      actionType: "FILTER" | "RESET" | "FETCH" | null;
    },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(`filter-archived-ucl-reservations-list`, {
        withCredentials: true,
        params: {
          query,
          carType,
          status,
          startDate,
          endDate,
          actionType,
        },
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// unarchive reservation
export const uclUnarchiveSingleReservation = createAsyncThunk(
  "uclReservation/unarchive-ucl-reservation",
  async (
    { reservationID, data }: { reservationID: String | undefined; data: any },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.put(
        `unarchive-ucl-reservation/${reservationID}`,
        data,
        {
          withCredentials: true,
        },
      );

      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get list of ucl archived reservations to be exported on csv file
export const uclExportArchivedReservationsList = createAsyncThunk(
  "uclReservation/ucl-export-archived-reservations-list",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.post(
        `export-archived-ucl-reservations-list`,
        data,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// delete ucl reservation
export const uclDeleteMultipleReservations = createAsyncThunk(
  "uclReservation/delete-multiple-ucl-reservations",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.put(`delete-multiple-ucl-reservations`, data, {
        withCredentials: true,
      });

      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// * actions
const uclReservationSlice = createSlice({
  name: "uclReservation",
  initialState: {
    reservation: {},
    reservations: [],
    exportedReservations: [],
    loading: false,
    errors: null,
    pagination: null,
  },
  reducers: {
    clearErrors: (state) => {
      state.errors = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // * get all user's reservation
      .addCase(getUclReservations.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(getUclReservations.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.pagination = action.payload.Pagination;
      })
      .addCase(getUclReservations.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      })

      // * create new reservation
      .addCase(createUclReservation.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(createUclReservation.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.pagination = action.payload.Pagination;
      })
      .addCase(createUclReservation.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      })
      // * cancel ucl reservation
      .addCase(cancelUclReservation.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(cancelUclReservation.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.pagination = action.payload.Pagination;
      })
      .addCase(cancelUclReservation.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      })
      // * update ucl reservation
      .addCase(updateUclReservation.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(updateUclReservation.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.pagination = action.payload.Pagination;
      })
      .addCase(updateUclReservation.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      })

      // * get ucl reservations list to be exported
      .addCase(uclExportReservationsList.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(uclExportReservationsList.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.exportedReservations = action.payload.Reservations;
      })
      .addCase(
        uclExportReservationsList.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.errors = action.payload.Description;
        },
      )
      // * resend ucl reservation
      .addCase(uclResendReservation.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(uclResendReservation.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
      })
      .addCase(uclResendReservation.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      })
      // * get ucl archived reservations list
      .addCase(uclArchivedReservationsList.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(uclArchivedReservationsList.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        uclArchivedReservationsList.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.errors = action.payload.Description;
        },
      )
      // * ucl delete reservation
      .addCase(uclDeleteSingleReservation.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(uclDeleteSingleReservation.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        uclDeleteSingleReservation.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.errors = action.payload.Description;
        },
      )
      // * filter ucl reservations
      .addCase(filterUclReservations.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(filterUclReservations.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.pagination = action.payload.Pagination;
      })
      .addCase(filterUclReservations.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
      })
      // * filter archived ucl reservations
      .addCase(filterArchivedUclReservations.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(filterArchivedUclReservations.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        filterArchivedUclReservations.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.errors = action.payload.Description;
        },
      )

      // * ucl unarchive reservation
      .addCase(uclUnarchiveSingleReservation.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(uclUnarchiveSingleReservation.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        uclUnarchiveSingleReservation.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.errors = action.payload.Description;
        },
      )

      // * get ucl archived reservations list to be exported
      .addCase(uclExportArchivedReservationsList.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(uclExportArchivedReservationsList.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.exportedReservations = action.payload.Reservations;
      })
      .addCase(
        uclExportArchivedReservationsList.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.errors = action.payload.Description;
        },
      )
      // * ucl delete multiple reservation
      .addCase(uclDeleteMultipleReservations.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(uclDeleteMultipleReservations.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.reservations = action.payload.Reservations;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        uclDeleteMultipleReservations.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.errors = action.payload.Description;
        },
      );
  },
});

export default uclReservationSlice.reducer;
